import { InfoOutlined } from '@mui/icons-material';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const StyledTooltipText = styled(Typography)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  textDecoration: 'underline',
  textDecorationStyle: 'dotted',
}));

/** Shrinks the SVG’s line box so the glyph centres with the text cap height, not the cell’s full line-height. */
const IconSlot = styled('span')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: 0,
}));

const InfoIcon = styled(InfoOutlined)(() => ({
  // Match the label size (inherits from Typography) so the icon sits on the same line as the copy
  fontSize: '1em',
  width: '1em',
  height: '1em',
  flexShrink: 0,
  display: 'block',
}));

type Props = {
  content: React.ReactNode;
  icon?: boolean;
  inline?: boolean;
} & TypographyProps;

const TooltipTriggerText: React.FC<Props> = ({
  content,
  icon,
  children,
  ...props
}) => {
  return (
    <StyledTooltipText {...props}>
      <span>{content}</span>
      {icon ? (
        <IconSlot>
          <InfoIcon aria-hidden />
        </IconSlot>
      ) : null}
    </StyledTooltipText>
  );
};

export default TooltipTriggerText;
